import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'react-bootstrap';

import { formatDate, _diff2Date, _formatDate } from '../../../utils';

import { makeGetToken } from '../../../lib/selector';
import { v4 as uuidv4 } from 'uuid';

import RenderDatePicker from '../../input/renderDatePicker';
import { summaryCashRequest } from '../../../containers/summary/actions';
import { setToast } from '../../../containers/client/actions';

import { translate } from 'react-i18next';
import { isEqual } from 'lodash';

class FormSearchSKT extends Component {
  submit = (values) => {
    const { typeOrder, startDate, endDate } = values;
    const { token, account, t } = this.props;
    if (!token) return;
    const maxDay = token && token['config'] ? token['config']['maxDay'] : 90;

    const _diff = _diff2Date(endDate, startDate);
    if (_diff < 0) {
      this._handleToast(t('txt-valid-time'));
      return;
    }
    if (_diff > maxDay) {
      this._handleToast(
        `${t('txt-valid-range-time')} ${maxDay} ${t('txt-day')}`
      );
      return;
    }
    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'GetCashstatement',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: account.acntNo,
        subAcntNo: account.subAcntNo,
        fromDate: _formatDate(startDate),
        toDate: _formatDate(endDate),
        nextKey: null,
        reqCount: '20',
      },
    };

    this.props.dispatch(summaryCashRequest(params));
    this.props.saveParams(params);
  };

  componentDidUpdate(preProps) {
    const { account, reset } = this.props;

    if (account && !isEqual(account, preProps.account)) {
      reset();
      setTimeout(() => {
        if (this.refSubmit) this.refSubmit.click();
      }, 100);
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: this.props.t('txt-notice'),
    };
    this.props.dispatch(setToast(toastMsg));
  };

  render() {
    const { handleSubmit, submitting, startDate, endDate, t } = this.props;

    return (
      <form
        className="p-2 mt-2 form-search-head"
        onSubmit={handleSubmit(this.submit)}
      >
        <Form.Group className="d-flex mb-0 p-2" controlId="formPlaintextDate">
          <label className="text-white-50 fz-14" style={{ width: '20mm' }}>
            {t('txt-label-from')}
          </label>
          <div style={{ width: '50mm' }}>
            {startDate && (
              <Field
                classname="form-control form-input fz-14"
                name="startDate"
                type="start"
                startDate={startDate}
                endDate={endDate}
                component={RenderDatePicker}
              />
            )}
          </div>
          <label className="text-white-50 fz-14" style={{ width: '20mm' }}>
            {t('txt-label-to')}
          </label>
          <div style={{ width: '50mm' }}>
            {endDate && (
              <Field
                classname="form-control form-input fz-14"
                name="endDate"
                type="end"
                startDate={startDate}
                endDate={endDate}
                component={RenderDatePicker}
              />
            )}
          </div>
          <button
            ref={(el) => (this.refSubmit = el)}
            type="submit"
            disabled={submitting}
            className="btn-reload fz-14 font-weight-bold text-white ml-2 w-auto"
          >
            {t('txt-search')}
          </button>
        </Form.Group>
      </form>
    );
  }
}

FormSearchSKT = reduxForm({
  form: 'saoketien',
  enableReinitialize: true,
})(FormSearchSKT);

const selector = formValueSelector('saoketien');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();

  const mapStateToProps = (state, props) => {
    const token = getToken(state);

    const { startDate, endDate } = selector(state, 'startDate', 'endDate');

    const numDay = token && token['config'] ? token['config']['numDay'] : 30;

    const d = new Date();
    d.setDate(d.getDate() - numDay);

    return {
      token,
      startDate,
      endDate,
      initialValues: {
        endDate: formatDate(new Date(), '/', 'dmy'),
        startDate: formatDate(d, '/', 'dmy'),
      },
    };
  };
  return mapStateToProps;
};

FormSearchSKT = connect(makeMapStateToProps)(FormSearchSKT);

export default translate('translations')(FormSearchSKT);
